import { render, staticRenderFns } from "./NurseDashboard.vue?vue&type=template&id=5a2ebad8&scoped=true&"
import script from "./NurseDashboard.vue?vue&type=script&lang=js&"
export * from "./NurseDashboard.vue?vue&type=script&lang=js&"
import style0 from "./NurseDashboard.vue?vue&type=style&index=0&id=5a2ebad8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2ebad8",
  null
  
)

export default component.exports